declare global {
  interface NavigatorUAData {
    readonly mobile: boolean
    getHighEntropyValues(
      hints: (
        | 'mobile'
        | 'platform'
        | 'platformVersion'
        | 'architecture'
        | 'model'
        | 'uaFullVersion'
      )[]
    ): Promise<{
      mobile?: boolean
      platform?: string
      platformVersion?: string
      architecture?: string
      model?: string
      uaFullVersion?: string
    }>
    toJSON(): { brands: { brand: string, version: string }[], mobile: boolean, platform?: string }
  }

  interface Navigator {
    readonly userAgentData?: NavigatorUAData
  }
}
export function isMobileDevice(): boolean {
  const nav = window.navigator

  // ───── 1. UA Client Hints (Gold Standard) ─────────────────────
  if (nav.userAgentData !== undefined) {
    const mobile = nav.userAgentData.mobile
    if (typeof mobile === 'boolean') {
      return mobile
    }
  }

  // ───── 2. Touch + Coarse + Size + Orientation ─────────────────
  const hasTouch = 'ontouchstart' in window || (nav.maxTouchPoints ?? 0) > 0
  const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches
  const isSmallScreen = window.innerWidth <= 768
  const hasOrientation = 'orientation' in window

  if (hasTouch && hasCoarsePointer && isSmallScreen && hasOrientation) {
    return true
  }

  // ───── 3. iPadOS Desktop UA Fix ──────────────────────────────
  const ua = nav.userAgent
  const isIPadDesktop = /Macintosh/i.test(ua) && (nav.maxTouchPoints ?? 0) > 1
  if (isIPadDesktop) return true

  // ───── 4. Legacy UA Fallback ─────────────────────────────────
  const legacyMobile = /(Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini)/i.test(ua)
  if (legacyMobile) return true

  // ───── 5. Final Safety Net ───────────────────────────────────
  return hasTouch && window.innerWidth <= 500
}
